export class Order {
    token: any;
    types: Array<OrderTokenType> = [];
    messages: Array<any> = [];

    /**
     * Checks whether a token type is contained in the order
     * @param tokenType the token type checked for
     * @returns True if the specified token type is present in the order
     */
    public containsTokenType(tokenType:OrderTokenType): boolean {
        return this.types.includes(tokenType);
    }

    /**
     * Checks whether a token type is the only present token type in the order
     * @param tokenType the token type checked for
     * @returns True if the specified token type is the only present token type in the order
     */    
    public containsSolelyTokenType(tokenType:OrderTokenType): boolean{
        return this.types.length == 1 && this.types[0] == tokenType;
    }

    /**
     * Checks whether a token type is the top level (the first in the list) token type
     * @param tokenType the token type checked for
     * @returns True if the specified token type is the top level token type
     */      
    public hasTopLevelTokenType(tokenType:OrderTokenType): boolean{
        return this.hasTokenTypes() && this.types[0] == tokenType;
    }

    /**
     * Returns whether the order has token types
     * @returns True if the order has token types
     */      
    public hasTokenTypes(): boolean {
        return this.types.length > 0;
    }
}

export enum OrderTokenType {
    None = -1,
    TruckDriverAssignment,
    LoadingStartTime,
    RequestEndLoadingConfirmation,
    LoadingEndTimeConfirmation
}